import { K8_REPORT_UNIT_SECTION } from 'pages/LessonCompletionReport/constants'
import { VIEW_OPTION_PATHS } from 'utils/adminExperienceHelpers'

export const ADMIN_PATH = '/'

const normalizeRecentLeaderDashboardPath = recentLeaderDashboardUrl => {
  const withoutLeadingSlash = recentLeaderDashboardUrl.replace(/^\//, '')

  if (withoutLeadingSlash.startsWith('admin/')) {
    return withoutLeadingSlash
  }

  return `admin/${withoutLeadingSlash}`
}

export const buildAdminDashboardBackPath = ({
  isDwbReportRoute = false,
  k8ReportUnitSection,
  recentLeaderDashboardUrl,
  selectedProgramKey,
}) => {
  if (recentLeaderDashboardUrl) {
    return `/${normalizeRecentLeaderDashboardPath(recentLeaderDashboardUrl)}`
  }

  if (isDwbReportRoute || selectedProgramKey === 'DWB') {
    return '/admin/program/dwb'
  }

  if (k8ReportUnitSection === K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS) {
    return `/admin/program/k8/${VIEW_OPTION_PATHS.SPECIALIZED_UNITS}`
  }

  return `/admin/program/k8/${VIEW_OPTION_PATHS.CORE}`
}

export const buildK8ReportSitePath = (unitSection, siteId) =>
  `/reports/k8/${unitSection}?site=${siteId}`

export const buildDwbReportSitePath = siteId => `/reports/dwb?site=${siteId}`

export const SCHOOL_SUMMARY_BREADCRUMB = 'School Overview'
export const LESSON_COMPLETION_REPORTS_TITLE = 'Lesson Completion Reports'
